export enum LegalInfoActionTypes {
    FETCH_LEGAL_INFO = '@@legalInfo/FETCH_LEGAL_INFO',
    FETCH_LEGAL_INFO_SUCCEED = "@@legalInfo/FETCH_LEGAL_INFO_SUCCEED",
    FETCH_LEGAL_INFO_FAILED = "@@legalInfo/FETCH_LEGAL_INFO_FAILED",
  }
  